<template>
    <div class="text-center">
      <v-dialog v-model="dialog" width="500" persistent> 
  
        <v-card>
          <v-card-title class="text-h5 blue darken-3 white--text py-2">
            Ver documentos subidos
            <v-spacer></v-spacer>
            <v-btn color="white" text @click="dialog=false">
              X
            </v-btn>
          </v-card-title>
  
          <v-card-text class="pt-2">  
            <div v-for="(c,i) in cargados" :key="i">
                <p class="green white--text pa-1"> <b>{{ c.documentoPersona.tipoDocumentoPersona.nombre }}</b> </p>
                <v-btn color="orange" outlined small @click="open(c.documentoPersona)">
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
                <p class="mb-0"> <b>Subido:</b> {{ parseFecha(c.actualizadoEn) }} </p>
                <p class="mb-0"> <b>Estado:</b> {{ c.documentoPersona.estado }} </p>
                <p class="mb-0"> <b>Revision:</b> {{ c.documentoPersona.estadoRevision }} </p>
                
                <div v-for="(d,j) in c.documentoPersona.datos" :key="j">
                    <p> <b>{{ d.etiqueta }}:</b> {{ d.valor }} </p>
                </div>
                
            </div>
          </v-card-text>
  
          <v-divider></v-divider>
  
          <v-card-actions>
            <v-btn color="red" outlined @click="dialog=false">
                Cerrar
            </v-btn>
            <v-spacer></v-spacer>
            
          </v-card-actions>
        </v-card>
      </v-dialog>

      <Ver ref="refVer"/>
    </div>
  </template>

<script>
import { ref } from 'vue';
import Ver from './view.vue'

export default {
  components:{Ver},
  data () {
    const dialog = ref(false); 
    const cargados = ref([]); 

    const openmodal = (ups) => { 
        cargados.value = ups;
        dialog.value = true;
        window.console.log('ups'); 
    } 

    const open = (docper) => {
        this.$refs.refVer.openmodal(docper)
    }

    const parseFecha = (f) => {
        if(!f) return "";
        const p1 = f.split('T');
        const p2 = p1[1].split(':');
        return p1[0] +' '+p2[0]+':'+p2[1]
    }

    return { 
        dialog,
        cargados,
        parseFecha,
        openmodal, 
        open,
    }
  },
}
</script>